<template lang="html">
  <div class="catalogo--view catalogo">
    <intro></intro>

    <section :id="$t('catalogo.nav_options.cat_general.id')" class="cat-general sec-center pad-sec">
      <div class="container waypoints" data="fadeInUp">
        <h3 class="title title-36">
          {{ $t("enlaces.textos.catalogo_general") }}
        </h3>
        <p v-html="$t('catalogo.cat_general.texto')"></p>
      </div>
    </section>

    <buscador></buscador>

    <section :id="$t('catalogo.nav_options.cat_turbo.id')" class="cat-turbo pad-sec">
      <div class="container waypoints flex wrap" data="fadeInUp">
        <div class="col-100 flex column justify-center">
          <div class="container texto">
            <h3 class="title title-36">
              {{ $t("catalogo.cat_turbo.titulo") }}
            </h3>
            <p v-html="$t('catalogo.cat_turbo.texto')"></p>
          </div>
        </div>
        <div class="col-100 flex row justify-around">
          <a class="go" :href="getServer+'bundles/prensa/descargables/public/pdfs/by-vehicle-model.zip'">{{ $t("catalogo.cat_turbo.por_vehiculo") }}
            <i class="fa-sharp fa-solid fa-arrow-right-long" aria-hidden="true"></i></a>
          <a class="go" :href="getServer+'bundles/prensa/descargables/public/pdfs/by-turbo.zip'">{{ $t("catalogo.cat_turbo.por_turbo") }}
            <i class="fa-sharp fa-solid fa-arrow-right-long" aria-hidden="true"></i></a>
        </div>
      </div>
    </section>

    <!-- CATÁLOGO JUNTAS COMPRESOR -->
    <!--
      El id se fija aqui porque `catalogo.nav_options` no tiene entrada para esta
      seccion en ningun idioma: el `$t()` anterior devolvia la ruta de la clave y
      se publicaba como id="catalogo.nav_options.cat_juntas_compresor.id". La
      navegacion ya usa la clase, no el id, asi que no hace falta traducirlo.
    -->
    <section id="cat-juntas-compresor" class="cat-juntas-compresor pad-sec">
      <div class="container waypoints flex wrap" data="fadeInUp">
        <div class="col-100 flex column justify-center">
          <div class="container texto">
            <h3 class="title title-36">
              {{ $t("catalogo.cat_juntas_compresor.titulo") }}
            </h3>
            <div v-html="$t('catalogo.cat_juntas_compresor.texto')"></div>
          </div>
        </div>
        <div class="col-100 flex row justify-around">
          <!-- ruta en servidor ajusa para pdf y zips /var/www/gestor_ajusa/src/PrensaBundle/Resources/public/descargables/public/pdfs -->
          <a class="go" :href="getServer+'bundles/prensa/descargables/public/pdfs/juntas-compresor-by-model.zip'">{{ $t("catalogo.cat_juntas_compresor.por_vehiculo") }}
            <i class="fa-sharp fa-solid fa-arrow-right-long" aria-hidden="true"></i></a>
          <a class="go" :href="getServer+'bundles/prensa/descargables/public/pdfs/juntas-compresor-by-compressor.zip'">{{ $t("catalogo.cat_juntas_compresor.por_turbo") }}
            <i class="fa-sharp fa-solid fa-arrow-right-long" aria-hidden="true"></i></a>
        </div>
      </div>
    </section>


    <!-- CATALOGO JUNTAS ESPECIALES -->
    <section class="cat-juegos-juntas  pad-sec" :id="$t('catalogo.cat_juegoJuntas.idUrl')">
      <div class="container waypoints" data="fadeInUp">
        <h3 class="title title-36">
          {{ $t("enlaces.textos.catalogo_juegosJuntas") }}
        </h3>
        <p v-html="$t(`catalogo.cat_juegoJuntas.texto`)"></p>
        <div class="col-100 flex row justify-around enlaces-catalogos">
          <a class="go" :href="getServer+'bundles/prensa/descargables/public/pdfs/juntasEspeciales/gasket-set-catalogue-ajusa.pdf'" target="_blank">{{ $t("catalogo.cat_juegoJuntas.descarga_completo") }}
            <i class="fa-sharp fa-solid fa-arrow-right-long" aria-hidden="true"></i></a>
          <span class="go" @click="mostrarJuegosJuntas()">{{ $t("catalogo.cat_juegoJuntas.descarga_juegos.title") }}
            <i class="fa-sharp fa-solid fa-arrow-right-long" aria-hidden="true"></i></span>
        </div>

        <JuegosJuntas v-if="showJuegosJuntas"></JuegosJuntas>

      </div>
    </section>

    <section class="cat-turbo motorsport sec-center pad-sec">
      <div class="container waypoints  flex column justify-center align-center" data="fadeInUp">
        <h3 class="title title-36">{{ $t("catalogo.motorsport.titulo") }}</h3>
        <div v-html="$t('catalogo.motorsport.texto')"></div>
        <a class="go" :href="'/static/pdf/ajusa-motorsports.pdf'" target="_blank">{{ $t("catalogo.cat_juegoJuntas.descarga_completo") }}
          <i class="fa-sharp fa-solid fa-arrow-right-long" aria-hidden="true"></i></a>
      </div>
    </section>

    <section class="tec-alliance sec-foto blue">
      <img class="w-100" src="/static/img/bkg/bkg-tec-alliance.webp" :alt="$t('catalogo.alt_images.catalog_online')" width="1514" height="1044" loading="lazy">
      <div class="container waypoints flex row-reserve justify-start" data="fadeInLeft">
        <div class="col-50 text-container">
          <a target="_blank" :href="$t('enlaces.catalogo_online')">{{ $t("enlaces.textos.tec_alliance") }}</a>
          <!-- Los niveles estaban invertidos: el h3 era el antetitulo pequeno y
               el h4 el titulo grande de la seccion. -->
          <p class="title-18">{{ $t("catalogo.tec_alliance.intro") }}</p>
          <h2 class="title title-52">
            {{ $t("catalogo.tec_alliance.titulo") }}
          </h2>
          <p v-html="$t('catalogo.tec_alliance.texto_1')"></p>
          <p v-html="$t('catalogo.tec_alliance.texto_2')"></p>
          <p class="go">
            {{ $t("catalogo.tec_alliance.boton")
            }}<i class="fa-sharp fa-solid fa-arrow-right-long" aria-hidden="true"></i>
          </p>
        </div>
      </div>
    </section>

    <banner-ajusa-th></banner-ajusa-th>

    <otras-secciones :data="['area_tecnica','solicite_catalogo']"></otras-secciones>
  </div>
</template>

<script lang="js">

  import Intro from '@/components/view-parts/intros/catalogo'
  import Buscador from '@/components/view-parts/catalogo-parts/buscador'
  import BuscadorRetenes from '@/components/view-parts/catalogo-parts/buscador-retenes'
  import JuegosJuntas from '@/components/view-parts/catalogo-parts/juegos-juntas-resultados'

  import bannerAjusaTh from '@/components/parts/banner-ajusa-th'

  import Otras_Secciones from '@/components/parts/acceso-a-secciones';



  import Vue from 'vue';
  import axios from 'axios';
  import VueAxios from 'vue-axios';
  import { mapGetters } from 'vuex';
  Vue.use(VueAxios, axios);

  export default {
    name: 'catalogo',
    props: [],
    data() {
      return {
        showAjusath: false,
        showJuegosJuntas: false,

      }
    },

  mounted() {
      document.head.querySelector("[name='keywords']").content = this.$t(`enlaces.seo.catalogo.keyword`);
      if (!!location.hash) {
        let where = location.hash;
        switch (where) {
          case '#juntas-compresor':
            $("html, body").animate({ scrollTop: $('.cat-juntas-compresor').position().top - 100 }, 1000);
            break;
          case '#brake-compressor-gasket':
            $("html, body").animate({ scrollTop: $('.cat-juntas-compresor').position().top - 100 }, 1000);
            break;
          case '#juntas-de-compressor':
            $("html, body").animate({ scrollTop: $('.cat-juntas-compresor').position().top - 100 }, 1000);
            break;
          default:
            // statements_def
            break;
        }
      }

      let to = this.$route.params.id;
      if ($("#" + to).length > 0) {
        this.scrollTo(to);
      }
    },
    computed: {
      ...mapGetters(['getServer', 'getLanguage']),
    },
    methods: {
      mostrarJuegosJuntas: function () {
        this.showJuegosJuntas = !this.showJuegosJuntas;
      },
      scrollTo(to) {
        if ($("#" + to).length > 0) {
          $('body,html').animate({ scrollTop: $("#" + to).position().top }, 800);
        }
      }
    },
    components: {
      'intro': Intro,
      'buscador': Buscador,
      'buscador-retenes': BuscadorRetenes,
      'otras-secciones': Otras_Secciones,
      'banner-ajusa-th': bannerAjusaTh,
      'JuegosJuntas': JuegosJuntas
    },
    watch: {
      "$route.params"() {
        if (this.$route.params.id) { 
          this.scrollTo(this.$route.params.id);
        }
      },
      "$route.params.lang"() {
        if (this.$route.params.lang === 'us') { 
          document.head.querySelector("[name='keywords']").content = this.$t(`enlaces.seo.catalogo.keyword`);
        }
      }
    },
  }
</script>

<style scoped>
  .catalogo {}

  .cat-retenes {
    background: #02203c;
    color: white;
  }

  .cat-juntas-compresor {
    text-align: center;
  }

  .cat-juegos-juntas {
    text-align: center;
    background: #e6ecf1;
  }

  .go {
    cursor: pointer;
  }

  @media screen and (max-width: 600px) {
    .enlaces-catalogos {
      flex-direction: column;
    }

    .go {
      margin: 5px 0;
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/views/catalogo.vue